import {
    Avatar,
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    ListSubheader,
    Typography
} from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { useState } from 'react';

import { Button as MuiButton } from '@material-ui/core';
import RichTextInput from 'ra-input-rich-text';
import {
    CheckboxGroupInput,
    NumberInput,
    required,
    SaveButton,
    SelectInput,
    SimpleForm,
    TextField,
    TextInput,
    Toolbar,
    useNotify,
} from 'react-admin';
import MarkdownView from 'react-showdown';
import { DangerousHTMLDiv } from '../../../components/dangerousHTMLDiv';
import { ListAttachments } from '../../../components/list-attachments/list-attachments.component';
import { Spacer } from '../../../components/spacer';
import dataProvider from '../../../providers/data-provider';
import { stringAvatar } from '../../../utils/functions';

const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('pt-BR');
};

const TaskCompletionDialog = ({
    open,
    onClose,
    activity,
    task,
    taskCompletion,
    isAiFeedback = false,
    onEvaluated,
}) => {
    const notify = useNotify();
    const [saving, setSaving] = useState(false);

    if (!taskCompletion) return null;

    const record = {
        ...taskCompletion,
        task,
    };

    const evaluated = record.evaluated;
    const team = record.team;
    const hasAIEvaluatedActivity = isAiFeedback ? evaluated : true

    const handleSubmit = async (values, appropriate) => {
        try {
            setSaving(true);
            const response = await dataProvider.post(
                'school-activity-task-completions',
                `${record.id}/evaluate`,
                { ...values, appropriate }
            );

            if (response.status === 500) {
                notify('Erro', 'error');
            } else {
                notify('Avaliação realizada com sucesso', 'success');
                if (onEvaluated) {
                    onEvaluated();
                }
            }
        } catch (error) {
            console.error(error);
            notify('Erro ao salvar avaliação', 'error');
        } finally {
            setSaving(false);
            onClose();
        }
    };

    const handleUndo = async () => {
        try {
            setSaving(true);
            const response = await dataProvider.delete(
                'school-activity-task-completions',
                { id: `${record.id}/clearEvaluate` }
            );

            if (response.status === 500) {
                notify('Erro', 'error');
            } else {
                notify('Correção removida com sucesso', 'success');
                if (onEvaluated) {
                    onEvaluated();
                }
            }
        } catch (error) {
            console.error(error);
            notify('Erro ao desfazer avaliação', 'error');
        } finally {
            setSaving(false);
            onClose();
        }
    };

    const ToolbarForm = (props) => (
        <Toolbar {...props}>
            <MuiButton
                style={{ marginLeft: 5 }}
                variant="contained"
                onClick={onClose}
                size="small"
                disabled={saving}
            >
                Cancelar
            </MuiButton>
            <Spacer />
            {!isAiFeedback && (
                <MuiButton
                    style={{ marginRight: 5 }}
                    variant="contained"
                    startIcon={<Delete />}
                    disabled={!evaluated || saving}
                    onClick={handleUndo}
                    size="small"
                >
                    Desfazer avaliação
                </MuiButton>
            )}
            {!isAiFeedback && (
                <SaveButton
                    style={{ marginRight: 5 }}
                    label="Salvar e apropriar aos autos"
                    submitOnEnter={false}
                    onSave={(values) => handleSubmit(values, true)}
                    size="small"
                    disabled={saving}
                />
            )}
            <SaveButton
                label={hasAIEvaluatedActivity ? "Salvar" : "Aguardando correção por IA"}
                submitOnEnter={false}
                onSave={(values) => handleSubmit(values, false)}
                size="small"
                disabled={!hasAIEvaluatedActivity || saving}
            />
        </Toolbar>
    );

    const sortTeamMemberships = (a, b) => { return a.user_context.user.name > b.user_context.user.name ? 1 : -1 }

    const teamMemberships = team?.team_memberships || [];
    const filteredMemberships =
        record.role?.id
            ? teamMemberships.filter((m) => m.role?.id === record.role.id).sort(sortTeamMemberships)
            : teamMemberships.sort(sortTeamMemberships);

    const translateWorkload = (w) => {
        if (w === 'G') return 'Nota'
        else if (w === 'T') return 'Carga horária'
        else if (w === 'C') return 'Cumprimento de tarefa'
    }

    const validateRequired = [required("Campo obrigatório")]

    const calcGrade = (grade) => {
        if (grade === null) return undefined;
        const value = parseFloat(
            String(grade).trim().replace(',', '.')
        );
        return Number.isFinite(value) ? value : undefined;
    }

    const choices = [{ id: 'ct', name: 'Cumpriu totalmente' }, { id: 'cp', name: 'Cumpriu parcialmente' }, { id: 'nc', name: 'Não cumpriu' }]

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                {evaluated ? 'Revisar avaliação' : 'Avaliar movimentação'}
            </DialogTitle>

            <DialogContent dividers>
                <Box mb={2}>
                    <Typography variant="subtitle2" color="textSecondary">
                        Atividade
                    </Typography>
                    <Typography variant="body1">
                        {activity?.name} — {activity?.class?.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Período: {formatDate(activity?.start_date)} - {formatDate(activity?.end_date)}
                    </Typography>
                </Box>

                <List
                    dense
                    style={{ display: 'flex', flexFlow: 'wrap', justifyContent: 'space-between' }}
                    subheader={
                        <ListSubheader style={{ width: '100%' }} disableSticky>
                            Alunos — {team?.name || 'Equipe'}
                        </ListSubheader>
                    }
                >
                    {filteredMemberships.map((team_membership, index) => (
                        <ListItem key={index} style={{ maxWidth: '30%' }}>
                            <ListItemAvatar>
                                <Avatar variant={'circle'} {...stringAvatar(team_membership.user_context?.user?.name || "")} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={team_membership.user_context?.user?.name}
                                secondary={team_membership.user_context?.user?.email}
                            />
                        </ListItem>
                    ))}
                </List>

                <Box paddingLeft={2} paddingRight={2}>
                    <Typography
                        color="textSecondary"
                        style={{
                            fontSize: '0.875rem',
                            fontFamily: 'Roboto',
                            fontWeight: 500,
                            lineHeight: '48px',
                        }}
                    >
                        Observações do aluno
                    </Typography>

                    <DangerousHTMLDiv html={record.text} style={{ overflowWrap: 'anywhere' }} />
                </Box>

                <List
                    subheader={
                        <ListSubheader disableSticky>
                            Anexos
                        </ListSubheader>
                    }
                >
                    <ListAttachments
                        attachments={record.attachments}
                        enableDelete={false}
                        relatedResource="school-activity-task-completions"
                    />
                </List>

                {isAiFeedback && (
                    <>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            style={{ fontWeight: 'bold', paddingLeft: 16 }}
                        >
                            Feedback da IA
                        </Typography>
                        <Typography style={{ padding: '8px 16px 8px 16px' }}>
                            <MarkdownView flavor="github" markdown={record.feedback} />
                        </Typography>
                    </>
                )}

                <Divider style={{ marginTop: 16, marginBottom: 16 }} />

                <SimpleForm
                    toolbar={<ToolbarForm />}
                    record={record}
                >
                    {task.checklist?.length > 0 && (
                        <CheckboxGroupInput
                            disabled={!hasAIEvaluatedActivity}
                            row={false}
                            source="checklist"
                            choices={task.checklist.map((el, idx) => ({
                                id: idx,
                                name: el.description,
                            }))}

                        />
                    )}

                    <TextField source='task.reference_grade' label='Valor da atividade' />

                    {
                        task?.grade_type === 'G' &&
                        <NumberInput
                            source='grade'
                            label={translateWorkload(task?.grade_type)}
                            validate={validateRequired}
                            fullWidth
                        />
                    }
                    {
                        task?.grade_type === 'T' &&
                        <TextInput
                            source='grade'
                            label={translateWorkload(task?.grade_type)}
                            validate={validateRequired}
                            fullWidth
                        />
                    }

                    {
                        task?.grade_type === 'C' &&
                        <SelectInput
                            source='grade'
                            label='Nota'
                            choices={choices}
                            optionText='name'
                            validate={validateRequired}
                            fullWidth
                        />
                    }
                    {!isAiFeedback && (
                        <RichTextInput source="feedback" label="Observações" fullWidth />
                    )}
                </SimpleForm>
            </DialogContent>
        </Dialog>
    );
};

export default TaskCompletionDialog;
